import React from 'react';
import {
  Box, Card, CardContent, Typography, Button,
  Accordion, AccordionSummary, AccordionDetails,
} from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import ExpandMoreIcon   from '@mui/icons-material/ExpandMore';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <Box sx={{ p: 3 }}>
        <Card
          variant="outlined"
          sx={{ borderColor: '#fca5a5', borderRadius: 1.5, maxWidth: 600, mx: 'auto' }}
        >
          <CardContent sx={{ p: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
              <ErrorOutlineIcon sx={{ color: '#c62828', fontSize: 28 }} />
              <Typography variant="h6" fontWeight={700} color="#c62828">
                Something went wrong loading this section
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              An unexpected error occurred. Click Retry to try again or refresh the page.
            </Typography>
            <Button
              variant="outlined"
              color="error"
              onClick={this.handleReset}
              sx={{ mb: 1 }}
            >
              Retry
            </Button>
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <Accordion sx={{ mt: 2 }} elevation={0} variant="outlined">
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="caption" color="text.secondary">
                    Error Details (dev only)
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Box
                    component="pre"
                    sx={{
                      fontSize: 11,
                      whiteSpace: 'pre-wrap',
                      overflow: 'auto',
                      color: '#c62828',
                      m: 0,
                    }}
                  >
                    {this.state.error.toString()}
                    {this.state.errorInfo?.componentStack}
                  </Box>
                </AccordionDetails>
              </Accordion>
            )}
          </CardContent>
        </Card>
      </Box>
    );
  }
}
